__turbopack_context__.v({
  "icon": "BasicTextField-module-scss-module__kjiCbW__icon",
});
